<template>
  <div
    class="alert d-flex align-items-center"
    :class="alertClasses"
  >
    <div class="d-flex align-items-center justify-content-between w-full">
      <div class="d-flex align-items-center gap-10">
        <i
          v-if="iconClasses"
          :class="iconClasses"
        />

        <span v-if="!$slots.default">
          {{ message }}
        </span>
        <slot v-else />
      </div>

      <slot
        v-if="dismissable"
        name="close"
      >
        <button
          type="button"
          class="close d-block"
          data-dismiss="alert"
          aria-label="Close"
        >
          <i class="hi hi-close hi-10 d-block px-5" />
        </button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppAlert',
  props: {
    message: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'info',
      validator: (value) => ['primary', 'secondary', 'success', 'danger', 'warning', 'info'].includes(value),
    },
    iconClasses: {
      type: String,
      default: '',
    },
    dismissable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    alertClasses() {
      return `alert-${this.type}`;
    },
  },
};
</script>
